/// REDUX ///
import { Dispatch } from "redux";
import { RootState } from "api/reducers";
/// ACTIONS ///
import { Action } from "api/action_types/shop_quote";
import { Action as AuthAction } from "api/action_types/authentication";
import { createBulkShopCutShapes } from "./create";
import { ActionType } from "api/action_types/shop_quote";
/// TYPES ///
import { IShopArea } from "api/types/shop_quote/area";
import { IShopCutShape } from "api/types/shop_quote/cut_shape";
import { IShopCutShapeSaveFailure } from "api/types/shop_quote/cut_shape";
import { Vector2 } from "api/types/sketch";
/// FUNCTIONS ///
import { getFirstShopSlabInArea } from "functions/sketch/get/shop_slab";
import { moveCutShapeToCenter } from "functions/sketch/move/cut_shape";

const CUT_SHAPE_DEFAULT_POSITION: Vector2 = { X: 900, Y: 400 };

export const repairFailedShopCutShapes = () => {
  return async (dispatch: Dispatch<Action | AuthAction>, getState: () => RootState) => {
    const { areas, cut_shapes, cut_shape_save_failures } = getState().shop_quote;

    if (!cut_shape_save_failures.length) {
      return null;
    }

    const repaired_shapes: IShopCutShape[] = [];

    for (let i = 0; i < cut_shape_save_failures.length; i++) {
      const failure: IShopCutShapeSaveFailure = cut_shape_save_failures[i];
      const cut_shape: IShopCutShape | undefined = cut_shapes.find(shape => shape.uuid === failure.uuid);
      if (!cut_shape) {
        continue;
      }

      const area: IShopArea | undefined = areas.find(item => item.uuid === cut_shape.area_uuid);
      if (!area) {
        continue;
      }

      const slab = getFirstShopSlabInArea(area);
      if (!slab) {
        continue;
      }

      const moved_shape: IShopCutShape = moveCutShapeToCenter(cut_shape, CUT_SHAPE_DEFAULT_POSITION);
      const repaired_shape: IShopCutShape = {
        ...moved_shape,
        area: area.id,
        area_uuid: area.uuid,
        slab_uuid: slab.uuid,
        fitted: false
      };

      dispatch({
        type: ActionType.UPDATE_LOCAL_SHOP_CUT_SHAPE,
        payload: repaired_shape
      });
      repaired_shapes.push(repaired_shape);
    }

    if (!repaired_shapes.length) {
      return null;
    }

    dispatch({
      type: ActionType.CLEAR_SHOP_CUT_SHAPE_SAVE_FAILURES
    });
    return await dispatch(createBulkShopCutShapes(repaired_shapes) as any);
  }
}
